import React, { useState } from "react";
import Input from "./Input";
import FileBase from "react-file-base64";
import { useDispatch, useSelector } from "react-redux";
import { createArticle } from "../actions/articleActions";
import { useHistory } from "react-router-dom";
import decode from "jwt-decode";

import Content from "./Content";
const CreateArticle = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session);
  const [formData, setFormData] = useState({
    author: { name: "", id: "" },
    name: "",
    title: "",
    summary: "",
    content: [],
    thumbnail: "",
  });

  const [error, setError] = useState();
  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};
    const data = {
      author: {
        name: user?.accessToken
          ? `${decode(user.accessToken).name}`
          : "Anonymous",
        id: user?.accessToken && `${decode(user.accessToken).id}`,
      },
      name: formData.name.toLowerCase().split(" ").join("-"),
      title: formData.title,
      summary: formData.summary,
      content: formData.content,
      thumbnail: formData.thumbnail,
    };

    // setArticles((prev) => [...prev, data]);
    const error = await createArticle(data, dispatch);

    error
      ? error.data.error.forEach((data) => {
          const { param, msg } = data;
          errors[`${param}`] = msg;
        })
      : (window.location.href = `/article/${data.name}`);

    setError(errors);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="create-article-container ">
        {/* <div className="search-article-container">
          <input type="text" placeholder="Search..." />
        </div> */}

        <form onSubmit={handleSubmit} className="widthContainer">
          <h1>Publish Article</h1>
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.name}
            name="name"
            id="name"
            autoComplete="off"
            placeholder={error && error.name}
            direction="column"
            errorHandler="true"
          />
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.title}
            name="title"
            id="title"
            autoComplete="off"
            placeholder={error && error.title}
            direction="column"
            errorHandler="true"
          />
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.summary}
            name="summary"
            id="summary"
            autoComplete="off"
            placeholder={error && error.summary}
            direction="column"
            errorHandler="true"
          />
          <Content formData={formData} setFormData={setFormData} />
          <div className="thumbnail-container">
            <label htmlFor="thumbnail">Thumbnail</label>
            <FileBase
              type="file"
              multiple={false}
              onDone={({ base64 }) =>
                setFormData({ ...formData, thumbnail: base64 })
              }
              name="thumbnail"
              id="thumbnail"
            />
            {error && <p style={{ color: "red" }}>{error.thumbnail}</p>}
          </div>

          {formData.content.length > 0 && user?.accessToken && (
            <button type="submit">Publish</button>
          )}
        </form>
      </div>
    </>
  );
};

export default CreateArticle;
